import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import { getTextAlignClass, getVerticalAlignClass } from './utils';
import { TextAlignPropType, VerticalAlignPropType } from '../../services/proptypes';

function CTA({ emphasis, children, textAlign, verticalAlign, ...extraProps }) {
  const extraClasses = [
    emphasis ? 'emphasis' : '',
    getTextAlignClass(textAlign),
    getVerticalAlignClass(verticalAlign),
  ].join(' ');

  return (
    <Grid.Column className={`cta-banner-item ${extraClasses}`} {...extraProps}>
      {children}
    </Grid.Column>
  );
}

CTA.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  emphasis: PropTypes.bool,
  textAlign: TextAlignPropType,
  verticalAlign: VerticalAlignPropType,
};

CTA.defaultProps = {
  children: [],
  emphasis: false,
  textAlign: undefined,
  verticalAlign: undefined,
};

export default CTA;
